<template>
  <div class="edit-modal">
    <div
      class="backdrop"
      @click.self="$emit('closed', { load: false })"
    >
      <div class="modal">
        <form @submit.prevent="handleSubmit">
          <div class="card" v-if="loading">
            <spinner class="card"/>
            <p class="loading">Record being added...</p>
          </div>
          <div class="card" v-if="learnerExists">
            <spinner class="card" v-if="loading"/>
            <p class="loading">{{ learnerExists.displayName }} already added</p>
          </div>
          <label>{{ record.displayName }}</label>
          <label>{{ record.grade }}</label>
          <button>Add To Teacher Records</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref, watchEffect } from 'vue' // , toRefs
import { db, serverTimestamp, addDoc, collection } from '@/firebase/config'
import Spinner from './Spinner.vue'
import getPosts from '@/composables/getPosts'

export default {
  name: 'EditClassModal',
  props: ['record'],
  components: { Spinner },
  setup (props, context) {
    const currentUser = inject('currentUser')
    const loading = ref(false)
    const filteredLearners = ref(null)
    const learnerExists = ref(null)
    const { myData, load } = getPosts()

    load(currentUser.state.grade + '/reports/teacher')

    watchEffect(() => {
      filteredLearners.value =
        myData.value ? myData.value.filter(learner => learner.displayName === props.record.displayName)
          : null
    })

    const handleSubmit = async () => {
      loading.value = true
      const post = {
        displayName: props.record.displayName,
        grade: props.record.grade,
        createdAt: serverTimestamp(),
        createdBy: currentUser.state.user.displayName
      }
      if (!filteredLearners.value[0]) {
        await addDoc(collection(db,
          '/schools/inspire-schools/' + currentUser.state.grade +
          '/reports/teacher'), post)
        context.emit('closed', { load: true, toasts: 'Record added' })
      } else {
        learnerExists.value = filteredLearners.value[0]
        context.emit('closed', { load: false, toasts: 'Record already exists!' })
      }
    }

    return { handleSubmit, loading, learnerExists }
  }
}
</script>

<style>
    .edit-modal .backdrop {
        top: 0;
        left: 0;
        position: fixed;
        background-color: fuchsia;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: grid;
        place-items: center;
        /* z-index: 99; */
    }
    .edit-modal .modal {
        border-radius: 10px;
        max-width: 400px;
        background: #fff;
        padding: .5em;
    }
    .edit-modal label {
      display: block;
    }
    .edit-modal .modal div.card {
        border: none;
    }
    .edit-modal .modal .loading {
        display: flex;
        justify-content: center;
        font-size: 18px;
        font-weight: 700;
    }
</style>
